import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

const setUserSelect = ({ commit }, data) => {
  commit('SET_USER_SELECT', data);
};

const setDivisionInfo = ({ commit }, data) => {
  commit('SET_DIVISION_INFO', data);
};

const setAllDivisionInfo = ({ commit }, data) => {
  commit('SET_ALL_DIVISION_INFO', data);
};

const setUserDivInfo = ({ commit }, data) => {
  commit('SET_USER_DIV_INFO', data);
};

const setUserDivData = ({ commit }, data) => {
  commit('SET_USER_DIV_DATA', data);
};

const setDivDataOne = ({ commit }, data) => {
  commit('SET_DIV_SELECT_ONE', data);
};

const setCurrentDivList = ({ commit }, data) => {
  commit('SET_CURRENT_DIV_LIST', data);
};

const setSearchRole = ({ commit }, data) => {
  commit('SET_SEARCH_ROLE', data);
};

const setDivisionListWithSecurityMgmt = ({commit}, data) => {
  commit('SET_DIV_WITH_SECURITY_MGMT', data);
}

export default {
  async USER_DIV_UPDATE(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/login-update`, param);
  },

  async USER_DIV_SELECT(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/select-user?${StringUtil.queryStringfy(param)}`);
    setUserSelect(store, data.data);
  },

  async USER_DIV_INFO(store, param) {
    const data = await RequestUtil.get(
      `${SDLUtil.API_URL}/cop/com/selectDivionList?${StringUtil.queryStringfy(param)}`,
    );
    setDivisionInfo(store, data.data);
  },

  async ALL_DIV_INFO(store) {
    const data = await RequestUtil.get(
      `${SDLUtil.API_URL}/cop/com/selectDivionList?active=false`,
    );
    setAllDivisionInfo(store, data.data);
  },

  async SEARCH_USER_DIV_INFO(store, param) {
    const data = await RequestUtil.get(
      `${SDLUtil.API_URL}/select-user-division-info?${StringUtil.queryStringfy(param)}`,
    );
    if (data.data) setUserDivInfo(store, data.data);
  },

  async SEARCH_USER_DIV(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/select-user-division?${StringUtil.queryStringfy(param)}`);
    setUserDivData(store, data.data);
  },

  async UPDATE_USER_DIV(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/update-user-division`, param);
  },

  async UPDATE_ADMIN_USER_DIV(store, param) {
    await RequestUtil.post(`${SDLUtil.API_URL}/update-admin-user-division`, param);
  },

  async CURRENT_DIV_LIST(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/current-division?${StringUtil.queryStringfy(param)}`);
    setCurrentDivList(store, data.data);
  },

  async DIV_SELECT_ONE(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/division-one?${StringUtil.queryStringfy(param)}`);
    setDivDataOne(store, data.data);
  },

  async SEARCH_ROLE_DIV(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/select-role-div?${StringUtil.queryStringfy(param)}`);
    setSearchRole(store, data.data);
  },

  async SEARCH_DIV_WITH_SECURITY_MGMT(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/divisions-with-security-mgmt`);
    setDivisionListWithSecurityMgmt(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/userdiv/userdivAction.js